import type { ShipmentVendorBranchResponse } from './api';

export const normalizeShipmentVendorBranch = (
  list: ShipmentVendorBranchResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.branchDesc,
    value: row.branchKey,
  }));
};
